export default __webpack_public_path__ + "static/media/tag_goodnight_en.e19cd295.gif";